import { useAppSelector } from '@/store/store-hooks'
import { RootState } from '@/store/store'
import MedSummaryEntriesTable from '@/medical-billing-summaries/entries/components/MedSummaryEntriesTable'
import { selectMedSummaryAssetForMatter } from '../store/selectors'

/**
 * All Entries tab of the living billing summary: binds the shared entries table to the
 * matter's asset. The layout only renders this once the asset exists.
 */
export default function MedSummaryAssetEntriesTab() {
  const activeMatterId = useAppSelector((state: RootState) => state.mattersState.activeMatterId)
  const asset = useAppSelector((state: RootState) => selectMedSummaryAssetForMatter(state, { matterId: activeMatterId ?? undefined }))

  if (!asset) return null
  return <MedSummaryEntriesTable parentId={asset.id} />
}
